import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { TEXT_FIELD_IS_REQUIRED } from '../../../utils/messages';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import './CustomMultiSelect.scss';

class CustomMultiSelect extends Component {
  static propTypes = {
    values: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    name: PropTypes.string,
    registerField: PropTypes.func,
    value: PropTypes.string,
    changeHandler: PropTypes.func.isRequired,
    focusHandler: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    status: PropTypes.string,
    isFocused: PropTypes.bool,
    errorText: PropTypes.string,
    multi: PropTypes.bool.isRequired,
    searchable: PropTypes.bool,
    closeOnSelect: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    isRequired: false,
    label: 'Select value',
    errorText: '',
    registerField: null,
    closeOnSelect: false,
    placeholder: 'Geo',
    disabled: false,
    className: '',
    searchable: true,
    value: '',
    isFocused: false,
    status: '',
    name: '',
  }

  state = {
    cacheValue: [],
  }

  componentDidMount() {
    const { name, registerField } = this.props;
    if (registerField) {
      registerField({ name, validator: this.standardValidator });
    }
  }

  standardValidator = (value) => {
    const { isRequired } = this.props;

    let valid = true;
    let errorText = '';

    if (isRequired && !(value && value.length)) {
      valid = false;
      errorText = TEXT_FIELD_IS_REQUIRED;
    }
    const status = valid
      ? TEXT_FIELD_STATUS.VALID
      : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };

  changeHandler = (value) => {
    const { changeHandler, name } = this.props;
    const cacheValue = [...this.state.cacheValue, ...value];

    this.setState(() => ({ cacheValue }), changeHandler({ name, value }));
  };

  focusHandler = () => {
    const { focusHandler, name } = this.props;
    // const value = [...this.state.cachedValue];
    focusHandler({ isFocused: true, name });
  };

  blurHandler = () => {
    const { focusHandler, name } = this.props;
    focusHandler({ isFocused: false, name });
  };

  renderArrow = ({ isOpen }) => {
    const arrowClassNames = classNames({ 'arrow-wrapper': true, 'is-open': isOpen });
    return (
      <div className={arrowClassNames}><div className="arrow" /></div>
    );
  }

  render() {
    const {
      name,
      values,
      value,
      isFocused,
      status,
      label,
      errorText,
      multi,
      searchable,
      closeOnSelect,
      placeholder,
      disabled,
      className,
    } = this.props;
    const multiSelectClasses = classNames({
      'multi-select-wrapper': true,
      'text-field-completed': status === TEXT_FIELD_STATUS.VALID,
      'text-field-failed': status === TEXT_FIELD_STATUS.INVALID,
      'show-float-label': isFocused || (value && String(value).length),
      'is-open': isFocused,
      disabled,
      [className]: true,
    });
    const renderPlaceholder = isFocused
      ? ''
      : placeholder;
    return (

      <div className={multiSelectClasses}>
        <div className="text-field-float-label">
          <span>{label}</span>
        </div>
        <Select
          name={name}
          value={value}
          onChange={this.changeHandler}
          onOpen={this.focusHandler}
          onClose={this.blurHandler}
          multi={multi}
          searchable={searchable}
          closeOnSelect={closeOnSelect}
          clearable={false}
          placeholder={renderPlaceholder}
          options={values}
          arrowRenderer={this.renderArrow}
          disabled={disabled}
        />
        <div className="text-field-error-text">
          <span>{errorText}</span>
        </div>
      </div>
    );
  }
}

export default CustomMultiSelect;



// WEBPACK FOOTER //
// ./src/components/_molecules/CustomMultiSelect/CustomMultiSelect.js